import React from "react";

const Projects = () => {
  const projects = [
    {
      icon: "🌳",
      title: "Project तरु",
      description:
        "विज्ञान का सबसे बड़ा और 3 माह तक चलने वाला प्रोजेक्ट है, जिसके अंतर्गत गत वर्ष हमारे द्वारा लगभग 1500 से अधिक पौधों को रोपित किया गया तथा उनके पोषणोपान के साथ साथ बाल विज्ञान द्वारा उनके संरक्षण पर भी ध्यान दिया जा रहा है।",
      impact: "🌱 1500+ पौधे रोपित",
      duration: "⏰ 3 माह",
      images: [
        "/assets/taru/image.png",
        "/assets/taru/image1.png",
        "/assets/taru/image2.png",
      ],
    },
    {
      icon: "🏞️",
      title: "Project निर्मल",
      description:
        "कटनी नगर स्थित अम्बेडकर तालाब, गौरीघाट बाढ़, कटंगा बाढ़, भर्रूखर बाढ़ क्षेत्रों में तालाब और जल निकायों की सफाई का व्यापक अभियान चलाया गया है।",
      impact: "🏞️ 4 मुख्य तालाब साफ",
      duration: "🔄 निरंतर",
      images: [
        "/assets/projectnirmal/1.png",
        "/assets/projectnirmal/2.png",
        "/assets/projectnirmal/3.png",
      ],
    },
    {
      icon: "🌍",
      title: "Project वसुंधरा",
      description:
        "अंतरराष्ट्रीय पृथ्वी दिवस के अवसर पर केंद्रीय विद्यालय, केन्द्रीय विद्यालय क्रमांक 2 एवं पीपल पत्ते केंद्रीय विद्यालय में बच्चों को पर्यावरण संरक्षण की विशेष जानकारी एवं पोस्टर प्रतियोगिता का आयोजन किया गया।",
      impact: "🎓 3 स्कूल",
      duration: "📅 वार्षिक",
      images: [
        "/assets/vasundhara/1.png",
        "/assets/vasundhara/2.png",
        "/assets/vasundhara/3.png",
      ],
    },
    {
      icon: "🏺",
      title: "Project तृप्ति",
      description:
        "कटनी नगर के 6 क्षेत्रों में गर्मी के दिनों में प्यासे लोगों और पक्षियों के लिए पानी के घड़े और प्याऊ की स्थापना की गई है। प्यासे मनुष्यों और पशु-पक्षियों की प्यास बुझाने का पुनीत कार्य।",
      impact: "💧 6 क्षेत्रों में जल व्यवस्था",
      duration: "☀️ ग्रीष्मकालीन",
      images: [
        "/assets/projecttrapti/1.png",
        "/assets/projecttrapti/2.png",
        "/assets/projecttrapti/3.png",
      ],
    },
    {
      icon: "🎨",
      title: "Project चित्रकारी",
      description:
        "शहर की दीवारों पर पर्यावरण संरक्षण, स्वच्छता और सामाजिक जागरूकता के संदेश देने वाली कलात्मक चित्रकारी का काम किया गया है। दीवारों को कैनवास बनाकर समाज में जागरूकता फैलाना।",
      impact: "🎨 कलात्मक जागरूकता",
      duration: "🔄 निरंतर",
      images: [
        "/assets/wallpaintings/1.png",
        "/assets/wallpaintings/2.png",
        "/assets/wallpaintings/3.png",
      ],
    },
    {
      icon: "♻️",
      title: "Project कबाड़ से जुगाड़",
      description:
        "कचरे और बेकार पड़ी चीजों को उपयोगी वस्तुओं में बदलना। पुराने मटकों, बोतलों और अन्य सामान को पुनः उपयोग करके पर्यावरण के अनुकूल उत्पाद बनाना। अपशिष्टों को संसाधन में बदलने का अभिनव प्रयास।",
      impact: "♻️ अपशिष्ट प्रबंधन",
      duration: "🔄 निरंतर",
      images: [
        "/assets/kabaad-se-jugaad/1.png",
        "/assets/kabaad-se-jugaad/2.png",
        "/assets/kabaad-se-jugaad/3.png",
      ],
    },
    {
      icon: "🛍️",
      title: "Project परिवर्तन",
      description:
        "कटनी नगर के 6 प्रमुख नगरीय क्षेत्रों में सिंगल यूज प्लास्टिक के उपयोग को रोकने हेतु जागरूकता एवं पेपर बैग्स का वितरण किया गया।",
      impact: "🛍️ 6 नगरीय क्षेत्र",
      duration: "📆 मासिक",
      images: [
        "/assets/project-nabhchar/1.png",
        "/assets/project-nabhchar/2.png",
        "/assets/project-nabhchar/3.png",
      ],
    },
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2 className="section-title">🚀 हमारे प्रोजेक्ट्स</h2>
        <p className="section-subtitle">
          कटनी जिले में शहर की सफाई और पर्यावरण संरक्षण के लिए चलाए जा रहे हमारे
          मुख्य कार्यक्रम
        </p>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <span className="project-icon">{project.icon}</span>
              <h3>{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-meta">
                <div className="meta-item">
                  <span className="meta-value">{project.impact}</span>
                </div>
                <div className="meta-item">
                  <span className="meta-value">{project.duration}</span>
                </div>
              </div>
              {project.images && project.images.length > 0 && (
                <div className="project-images">
                  <div className="images-grid">
                    {project.images.map((image, imageIndex) => (
                      <img
                        key={imageIndex}
                        src={image}
                        alt={`${project.title} - फोटो ${imageIndex + 1}`}
                        className="project-image"
                        loading="lazy"
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
